import { Navigate, Outlet } from 'react-router-dom';
import { HubSidebar } from '../components/hub/HubSidebar';
import { HubTopBar } from '../components/hub/HubTopBar';
import { useAuthStatus } from '../hooks/useAuthStatus';

export function HubLayout() {
  const { status, loading } = useAuthStatus();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-text-muted">
        Verifying session…
      </div>
    );
  }
  // /hub requires a live session AND the client-admin role. The two
  // guards exist because the hub and internal surfaces are intentionally
  // mutually exclusive — a consultant should never see /hub, a client
  // admin should never see /internal, even if they manually paste a URL
  // or click a stale link. Bounce destinations match the surface that
  // would have produced them: no session → /hub-login (the client-facing
  // landing), wrong role → /connect, which is the sign-in page. A consultant
  // signs in again there; a session with no role holds no grant anywhere, so
  // sending it to /internal only bounced off that layout's own guard.
  if (!status?.connected) return <Navigate to="/hub-login" replace />;
  if (status.role !== 'client-admin') return <Navigate to="/connect" replace />;

  return (
    <div className="flex h-screen bg-surface-1 text-text">
      <HubSidebar />
      <div className="flex flex-col flex-1 min-w-0">
        <HubTopBar />
        <main className="flex-1 overflow-y-auto px-8 py-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
